import { useMemo } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import { createPalette } from './palette';
import shadows from './shadows';
import typography from './typography';
import GlobalStyles from './globalStyles';
import customShadows from './customShadows';
import componentsOverride from './overrides';
import {
  primaryGradient,
  successGradient,
  infoGradient,
  warningGradient,
  errorGradient,
  createGlassCard,
  glassBackgrounds,
  gradientText,
  gradientBorder,
} from './gradients';
import { useThemeMode } from '../contexts/ThemeContext';

// ----------------------------------------------------------------------

export default function ThemeProvider({ children }) {
  const { actualTheme } = useThemeMode();

  const themeOptions = useMemo(
    () => ({
      palette: createPalette(actualTheme),
      shape: { borderRadius: 6 },
      typography,
      shadows: shadows(actualTheme),
      customShadows: customShadows(actualTheme),
      // Add gradients to theme
      gradients: {
        primary: primaryGradient.main,
        primaryLight: primaryGradient.light,
        primaryDark: primaryGradient.dark,
        success: successGradient.main,
        info: infoGradient.main,
        warning: warningGradient.main,
        error: errorGradient.main,
      },
    }),
    [actualTheme]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  // Add gradient utilities to theme
  theme.createGlassCard = createGlassCard;
  theme.glassBackgrounds = glassBackgrounds;
  theme.gradientText = gradientText;
  theme.gradientBorder = gradientBorder;

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
